var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-index"}},[_c('i',{staticClass:"el-icon-notebook-1",attrs:{"id":"i-pic"}}),_c('br'),_c('p',{staticClass:"p-title"},[_vm._v(" TiaDos - Tia多功能记事本 ")]),_c('p',{staticClass:"p-subtitle"},[_vm._v(" 使用左侧菜单选择页面")])])
}]

export { render, staticRenderFns }